import React,{ useState,useEffect } from "react";
import './styles.scss';
import { Container, Row, Col, Form, Button,Nav,ListGroup,ListGroupItem,Card,Table} from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateInfoUser,getCommandeById,UpdateUserAddresse,UpdateUserAddresseInf} from "../../../actions/user";
import "react-datepicker/dist/react-datepicker.css";
import { BiMap,BiShoppingBag,BiUserCircle,BiHistory } from 'react-icons/bi';
import { defaultimg } from "../../../assets/images";
import { Menu } from "../../../components";
import { ProductItem } from "../../../components";
import { getmesfavoris } from "../../../actions/user";

const Page = () => {
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.user)
    const { productsFavoris } = useSelector(state => state.mixedmode)

    useEffect(() => {
    dispatch(getmesfavoris({ user_id: user.user_id, token: user.api_token, api_token: user.api_token ,type:'product'}));

  }, []);

    const history = useHistory();
    function gotoCmd(item) {
       history.push(`/commande/detail/${item.id}`);
     }
    
    return (
        <div className="mesfavoris register bg778635 " >
            <Container>
                <Row>
            <Col  className="text-center mx-auto my-5"  lg="3">

               <Menu slug='favoris' />
               
                </Col>
              
                    <Col  className="text-center mx-auto my-5 menudashright"  >

                    <form className="mb-5">
                           
                            <h3 className="mb-4" > Mes articles favoris </h3>
                             <br/> 
                          <Row className="mb-3"  >

                     

                              {productsFavoris.map((item) => (
                                  <Col md={4} className='col-12' >
                                    <ProductItem item={item} favori={1} />
                                  </Col>
                                ))}
                           

                          </Row>



                    </form>
                        
                         






   

                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Page;